import '../scss/product.scss';
import '../components/product-slider';
import '../components/sliderSwiper';
import '../components/stickyAddCart';
import '../components/kit-options';
import { variantOnChange } from '../components/variantsProduct';
import { Accordion } from '../components/accordion';
import { Product } from '../components/product';
import { Engraving } from '../components/engraving';
import { ActivationKey } from '../components/activationKey';

variantOnChange('.variants');
new Accordion('.accordion-spec');
new Accordion('.accordion-dowloads');
new Product(
  '#product_description',
  '.product__description--description-links',
  '.engraving__event'
);
new Engraving(
  '.modal-engraving__form-variants_container__option',
  '.modal-engraving__form-variants_container__option-button',
  '.modal-engraving__form-characters p',
  '.modal-engraving__form input',
  '#engraving-add'
);
new ActivationKey();
